const validateLuhn = (number) => {
  let sum = 0;
  let shouldDouble = false;
  // Loop through digits in reverse order (from last digit to first)
  for (let i = number.length - 1; i >= 0; i--) {
    let digit = parseInt(number.charAt(i), 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9; // Subtract 9 if the result is greater than 9
      }
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0; // Valid if sum is divisible by 10
};

const checkOrgNr = (number) => {
  return validateLuhn(number);
};

export default checkOrgNr;
